import { z } from 'zod'

export const AssetClass = {
  profile: 'profile',
  pixel: 'pixel',
  ad_account: 'ad_account',
}

export const Platform = {
  facebook: 'facebook',
  instagram: 'instagram',
  google: 'google',
}

const assetUserSchema = z
  .object({
    asset_id: z.union([z.number(), z.string()]).optional(),
    token_id: z.number().optional(),
    token_type: z.string().optional(),
    is_active: z.boolean().optional(),
    platform_user_id: z.string().optional(),
    // null whenever the tasks couldn't be read — a Facebook page the user has
    // no MANAGE task on reports none, and the column is nullable.
    tasks: z.array(z.string()).nullable().optional(),
  })
  .passthrough()

const connectedAssetSchema = z
  .object({
    id: z.number().optional(),
    asset_id: z.string(),
    asset_class: z.string(),
    asset_label: z.string().optional(),
    platform: z.string(),
    is_active: z.boolean().optional(),
  })
  .passthrough()

const extraDataSchema = z.record(z.string(), z.unknown())

export const integrationDetailSchema = z
  .object({
    id: z.union([z.number(), z.string()]).optional(),
    partner_id: z.string().optional(),
    asset_id: z.string(),
    asset_label: z.string().optional(),
    asset_class: z.string(),
    platform: z.string(),
    is_active: z.boolean().optional(),
    is_enabled: z.boolean().optional(),
    date_created: z.string().optional(),
    date_last_updated: z.string().optional(),
    meta_profile_image: z.string().nullable().optional(),
    extra_data: extraDataSchema.nullable().optional(),
    connected_assets: z.array(connectedAssetSchema).optional(),
    asset_users: z.array(assetUserSchema).optional(),
    // POST /connect/assets/enrich only (app/core/integration/asset_enrichment.py).
    valid: z.boolean().nullable().optional(),
    error: z.string().nullable().optional(),
    currency: z.string().nullable().optional(),
    timezone: z.string().nullable().optional(),
    account_status: z.string().nullable().optional(),
    // Google pre-flight gating fields — top-level on enrich responses,
    // nested under extra_data on list responses (see extraDataSchema above).
    invitation_status: z.string().nullable().optional(),
    billing_valid: z.boolean().nullable().optional(),
    identity_verification_status: z.string().nullable().optional(),
    identity_verification_action_url: z.string().nullable().optional(),
  })
  .passthrough()

export const integrationDetailsResponseSchema = z.array(integrationDetailSchema)
